module.exports = __webpack_public_path__ + "img/bantusaku-footer.901cc2f1.png";